import ky, { type BeforeRequestHook, type KyInstance, type Options } from 'ky'
import { getAsyncToken } from '@tsyl/daisuke-auth-plugin'
import type { HttpClientPort, HttpRequestOptions } from './HttpClientPort'

export const injectToken: BeforeRequestHook = async (request) => {
  const token = await getAsyncToken()
  request.headers.set('Authorization', `${token}`)
}

export class KyHttpClient implements HttpClientPort {
  private readonly instance: KyInstance

  constructor(prefixUrl: string) {
    this.instance = ky.create({
      timeout: false,
      hooks: { beforeRequest: [injectToken] },
      // TODO fix backend so it returns proper content types and we don't have to put Accept */* on requests
      headers: { Accept: '*/*' },
      prefixUrl,
      retry: 0,
    } as Options)
  }

  get<T>(url: string, options?: HttpRequestOptions): Promise<T> {
    return this.instance.get(url, options).json<T>()
  }

  post<T>(url: string, options?: HttpRequestOptions): Promise<T> {
    return this.instance.post(url, options).json<T>()
  }

  put<T>(url: string, options?: HttpRequestOptions): Promise<T> {
    return this.instance.put(url, options).json<T>()
  }

  patch<T>(url: string, options?: HttpRequestOptions): Promise<T> {
    return this.instance.patch(url, options).json<T>()
  }

  delete<T>(url: string, options?: HttpRequestOptions): Promise<T> {
    return this.instance.delete(url, options).json<T>()
  }
}
